var FOCUSABLE_SELECTORS = 'a[href], button, input, textarea, select, details, [tabindex]:not([tabindex="-1"])';

/**
 * @param {HTMLElement} root
 * @param {string} className
 * @returns {HTMLElement[]}
 */
function byClass(root, className) {
    if (root) {
        if (root.nodeType === 11) { // == Node.DOCUMENT_FRAGMENT_NODE
            var result = [];
            for (var df = 0; df < root.childNodes.length; df++) {
                var childNode = root.childNodes[df];
                if (childNode.getElementsByClassName) {
                    result = result.concat(Array.prototype.slice.call(childNode.getElementsByClassName(className)));
                }
            }
            return result;
        }
        return Array.prototype.slice.call(root.getElementsByClassName(className));
    }
    return [];
}

/**
 * @param {HTMLElement} root
 * @param {string} className
 * @returns {?HTMLElement}
 */
function firstByClass(root, className) {
    var elements = byClass(root, className);
    return elements.length ? elements[0] : null;
}

/**
 * @param {HTMLElement} root
 * @param {string} selectors
 * @returns {HTMLElement|null}
 */
function querySelector(root, selectors) {
    return root.querySelector(selectors);
}

/**
 * @param {HTMLElement} root
 * @param {string} selectors
 * @returns {HTMLElement[]}
 */
function querySelectorAll(root, selectors) {
    return Array.prototype.slice.call(root.querySelectorAll(selectors));
}

function insertAfter(afterNode, element) {
    if (afterNode.nextSibling) {
        afterNode.parentNode.insertBefore(element, afterNode.nextSibling);
    } else {
        afterNode.parentNode.appendChild(element);
    }
}

/**
 * @param {HTMLElement} element
 * @param {string} [className]
 * @param {?HTMLElement} [limitElement]
 * @param {?boolean} [startFromEl] начинать поиск с самого элемента, а не его родителя
 * @returns {HTMLElement | null}
 */
function parent(element, className, limitElement, startFromEl) {
    if (!startFromEl) {
        element = element.parentElement;
    }
    while (element) {
        if (!className || !element.classList || element.classList.contains(className)) {
            return element;
        }
        if (limitElement && (limitElement === element)) {
            return null;
        }
        element = element.parentElement;
    }
    return element;
}

/**
 * Traverses elements from a given element to doc root until condition predicate is not satisfied
 * @param {Node} element starting element
 * @param {Function} stopCondition stop condition
 * @param {?HTMLElement} limitElement limiting element or null
 * @param {?boolean} [startFromEl] начинать поиск с самого элемента, а не его родителя
 * @returns {HTMLElement} last element in chain or null
 */
function traverseParents(element, stopCondition, limitElement, startFromEl) {
    if (!startFromEl) {
        element = element.parentElement;
    }
    while (element) {
        var res = stopCondition(element);
        if (res) {
            return element;
        }
        if (limitElement && (limitElement === element)) {
            return null;
        }
        element = element.parentElement;
    }
    return element;
}

/**
 * Traverse parents until find attribute and retur it's value
 *
 * @param {HTMLElement} element starting element
 * @param {string} attributeName stop condition
 * @param {?HTMLElement} [limitElement] limiting element or null
 * @returns {string|null} attribute value
 */
function getParentsAttrValue(element, attributeName, limitElement) {
    var getAttributeValue = function(el) {
            return el.getAttribute(attributeName);
        },
        target = traverseParents(element, getAttributeValue, limitElement, true);

    return target ? getAttributeValue(target) : null;
}

/**
 * Removes elements from DOM
 * @param {HTMLElement|HTMLElement[]} elements — single element or array to remove from DOM
 */
function remove(elements) {
    if (!Array.isArray(elements)) {
        elements = [elements];
    }

    var parent;
    elements.forEach(function(el) {
        parent = el.parentNode;
        if (parent) {
            parent.removeChild(el);
        }
    });

}

/**
 * Removes all listeners from elements by cloning it
 * @param {HTMLElement} el
 *
 * @returns {Node} new element
 */
function removeAllListeners(el) {
    var elClone = el.cloneNode(true);
    el.parentNode.replaceChild(elClone, el);

    return elClone;
}

function toElement(content) {
    var div = document.createElement('div');
    div.innerHTML = content;
    return div.firstElementChild;
}

function isTextEditorFocused() {
    var e = document.activeElement;
    return e.tagName === 'INPUT'
        || e.tagName === 'TEXTAREA'
        || e.hasAttribute('contenteditable');
}

var passiveSupported = undefined;

function isEventListenerOptionsSupported() {

    if (passiveSupported !== undefined) {
        return passiveSupported;
    }

    try {
        var options = {};

        Object.defineProperty(options, 'passive', {
            get: function () {
                passiveSupported = true;
                return false;
            }
        });

        window.addEventListener("test", null, options);
        window.removeEventListener("test", null, options);
    } catch (err) {
        passiveSupported = false;
    }

    return passiveSupported;
}

/**
 * Проверяем, принадлежит ли элемент тем, на которые можно сфокусироваться
 * @param el
 * @return {*|boolean}
 */
function isFocusableElement(el) {
    return el.matches(FOCUSABLE_SELECTORS)
        && !el.hasAttribute('disabled')
        && !el.getAttribute('aria-hidden')
        && !(el.dataset.withoutFocus === 'true');
}
/**
 * Получаем список всех фокусируемых элементов из переданного
 * @param {HTMLElement} [element=document] element
 * @returns {Array}
 */
function getKeyboardFocusableElements(element) {
    return Array.from(element.querySelectorAll(FOCUSABLE_SELECTORS)).filter(function (el) {
        return isFocusableElement(el)
    });
}

function forEach(collection, fun) {
    Array.prototype.slice.call(collection).forEach(fun);
    return collection;
}

function innerHeight(el) {
    try {
        return window.getComputedStyle(el, null).getPropertyValue('height');
    } catch (e) {
        return el.currentStyle.height;
    }
}

function outerSize(el, isWidth, includeMargins) {
    var result;
    if (el.nodeName === 'svg') {
        var rect = el.getBoundingClientRect();
        result = isWidth
            ? rect.width
            : rect.height;
    } else {
        result = isWidth
            ? el.offsetWidth
            : el.offsetHeight;
    }

    if (result !== null) {
        if (includeMargins) {
            var style = window.getComputedStyle
                ? window.getComputedStyle(el, null)
                : el.currentStyle;

            result += isWidth
                ? parseInt(style.marginLeft, 10) + parseInt(style.marginRight, 10)
                : parseInt(style.marginTop, 10) + parseInt(style.marginBottom, 10);
        }
        return result;
    }
    return 0;
}

function one(node, type, callback) {
    node.addEventListener(type, function handler(e) {
        e.target.removeEventListener(e.type, handler);
        return callback.call(this, e);
    });
}

function extractFocusableElement(element) {
    if (!element) {
        return null;
    }
    if (isFocusableElement(element)) {
        return element;
    }
    return getKeyboardFocusableElements(element)[0]
}

export default { byClass, firstByClass, querySelector, querySelectorAll, insertAfter, parent, traverseParents, getParentsAttrValue, removeAllListeners, toElement, isTextEditorFocused, isEventListenerOptionsSupported, isFocusableElement, getKeyboardFocusableElements, remove, forEach, innerHeight, outerSize, one, extractFocusableElement };

export { byClass, firstByClass, querySelector, querySelectorAll, insertAfter, parent, traverseParents, getParentsAttrValue, removeAllListeners, toElement, isTextEditorFocused, isEventListenerOptionsSupported, isFocusableElement, getKeyboardFocusableElements, remove, forEach, innerHeight, outerSize, one, extractFocusableElement };
